<template functional>
  <p :class="data.staticClass" v-bind="data.attrs">
    Consultez les informations
    <span class="font-bold text-orange"> mises à jour en temps réel</span>
    sur les produits commercialisés en France,
    <span class="font-bold">phytopharmaceutiques</span>,
    <span class="font-bold">macro-organismes</span>, produits utilisables en
    <span class="text-vert font-bold">agriculture biologique</span>,
    <span class="text-vert font-bold">biocontrôle</span>,
    <span class="font-bold"> biocides agricoles… </span>
  </p>
</template>

<script>
export default {
  name: 'PresentationText'
}
</script>
